export type TPricing = {
	name: string;
	description: string;
	status?: 'Request is Processed' | 'Current Plan' | 'outdated plan';
	value: number;
	currency: string;
	period: string;
	// types: string[];
	schemes: {
		IOSS: boolean;
		OSS: boolean;
		ImportUK: boolean;
	};
	items: TPricingItem[];
};

export type TPricingItem = {
	name: string;
	type: 'free' | 'add';
};

export const pricing: TPricing[] = [
	{
		name: 'IOSS or Import UK Starter',
		description: 'Simplified EU sales with IOSS automation.',
		// status: 'outdated plan',
		value: 9.9,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: false,
			ImportUK: false,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1,50€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS or Import UK Basic',
		description: 'Simplified EU sales with IOSS automation.',
		status: 'Current Plan',
		value: 79,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: false,
			ImportUK: false,
		},

		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS or Import UK Plus',
		description: 'Simplified EU sales with IOSS automation.',
		value: 329,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: false,
			ImportUK: false,
		},

		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '0,25€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},

	{
		name: 'OSS Starter',
		description: 'Simplified EU sales with IOSS automation.',
		value: 9.9,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: false,
			OSS: true,
			ImportUK: false,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1,50€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'OSS Basic',
		description: 'Simplified EU sales with IOSS automation.',
		value: 69,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: false,
			OSS: true,
			ImportUK: false,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1,50€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'OSS Plus',
		description: 'Simplified EU sales with IOSS automation.',
		value: 329,
		currency: '€',
		period: 'month',
		status: 'Request is Processed',
		schemes: {
			IOSS: false,
			OSS: true,
			ImportUK: false,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1,50€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS or Import UK + OSS Starter',
		description: 'Simplified EU sales with IOSS automation.',
		// status: 'outdated plan',
		value: 9.9,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: true,
			ImportUK: false,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1,50€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS or Import UK + OSS Basic',
		description: 'Simplified EU sales with IOSS automation.',
		// status: 'Current Plan',
		value: 79,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: true,
			ImportUK: false,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS or Import UK + OSS Plus',
		description: 'Simplified EU sales with IOSS automation.',
		value: 329,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: true,
			ImportUK: false,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '0,25€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},

	{
		name: 'IOSS + Import UK Starter',
		description: 'Simplified EU sales with IOSS automation.',
		// status: 'outdated plan',
		value: 9.9,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: false,
			ImportUK: true,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1,50€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS + Import UK Basic',
		description: 'Simplified EU sales with IOSS automation.',
		// status: 'Current Plan',
		value: 79,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: false,
			ImportUK: true,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS + Import UK Plus',
		description: 'Simplified EU sales with IOSS automation.',
		value: 329,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: false,
			ImportUK: true,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '0,25€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},

	{
		name: 'IOSS + Import UK + OSS Starter',
		description: 'Simplified EU sales with IOSS automation.',
		// status: 'outdated plan',
		value: 9.9,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: true,
			ImportUK: true,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1,50€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS + Import UK + OSS Basic',
		description: 'Simplified EU sales with IOSS automation.',
		// status: 'Current Plan',
		value: 79,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: true,
			ImportUK: true,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '1€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
	{
		name: 'IOSS + Import UK + OSS Plus',
		description: 'Simplified EU sales with IOSS automation.',
		value: 329,
		currency: '€',
		period: 'month',
		schemes: {
			IOSS: true,
			OSS: true,
			ImportUK: true,
		},
		items: [
			{
				name: '10 Free IOSS orders a month',
				type: 'free',
			},
			{
				name: '0,25€ per additional order',
				type: 'add',
			},
			{
				name: 'IOSS Registration',
				type: 'free',
			},
			{
				name: 'Automated Reporting & Filing',
				type: 'free',
			},
			{
				name: 'No-code integration',
				type: 'free',
			},
			{
				name: ' Free EAS configuration service',
				type: 'free',
			},
			{
				name: 'UK VAT add-on 10€ a month',
				type: 'add',
			},
		],
	},
];

export const filters = [
	{
		name: 'IOSS',
		text: 'Selling physical goods to EU',
	},
	{
		name: 'UK',
		text: 'When selling physical goods to UK',
	},
	{
		name: 'OSS',
		text: 'Intra-EU cross-border sales from one EU country to another EU country',
	},
];
